import type { StorageAdapter } from '@/services/storage/storage-adapter';
import type { Hunt, HuntSit, HarvestRecord } from '@/types/hunt';
import type { Waypoint } from '@/types/waypoint';

/**
 * Thin service for season recap data queries.
 * Provides a StorageAdapter-typed boundary so components never import `db` directly.
 * Used exclusively by SeasonRecapCard and its tests.
 */
export class SeasonRecapService {
  constructor(private adapter: StorageAdapter) {}

  async getHarvestsBySeason(seasonId: string): Promise<HarvestRecord[]> {
    return this.adapter.getHarvestRecordsBySeason(seasonId);
  }

  async getHuntsBySeason(seasonId: string): Promise<Hunt[]> {
    return this.adapter.getHuntsBySeason(seasonId);
  }

  async getHuntSitsByHunt(huntId: string): Promise<HuntSit[]> {
    return this.adapter.getHuntSitsByHunt(huntId);
  }

  async getWaypoint(id: string): Promise<Waypoint | null> {
    return this.adapter.getWaypoint(id);
  }
}
